import Box from '@mui/material/Box'
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { Theme } from '@mui/material/styles'
import * as React from 'react'

export const AddLocationCheckbox = (props: CheckboxProps) => (
  <Box
    sx={{ float: 'right', marginTop: (theme: Theme) => theme.spacing(-0.8) }}
  >
    <FormControlLabel
      control={
        <Checkbox {...props} onChange={props.onChange} color="primary" />
      }
      label="Add Location"
    />
  </Box>
)
